ALLOWED_CONTROLLER = 'people'
ALLOWED_ACTIONS = ['history']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  fromDate = $('#from_date')
  toDate = $('#to_date')

  $('*[data-selector="calendar"]').datepicker()

  $('#from_date, #to_date').on 'change', -> manageDates()

  manageDates = ->
    if checkDateFormat(fromDate.val()) && checkDateFormat(toDate.val())
      fromDate.val(verifyDate(fromDate.val()))
      toDate.val(verifyDate(toDate.val()))
      $('#date-warning-text').text('')
    else
      $('#date-warning-text').text('Both dates must be in format mm/dd/yyyy')

  verifyDate = (dateString) ->
    return if dateString == ''

    month = parseInt(/(^\d+)/.exec(dateString)[1])
    day = parseInt(/^\d+\/(\d+)/.exec(dateString)[1])
    year = parseInt(/^\d+\/\d+\/(\d+)/.exec(dateString)[1])
    maxDay = new Date(year, month, 0).getDate()

    month = 1 if month < 1
    month = 12 if month > 12
    day = 1 if day < 1
    day = maxDay if day > maxDay

    output = ''
    output = '0' if month < 10
    output = output + month.toString() + '/'
    output = output + '0' if day < 10
    output = output + day.toString() + '/' + year.toString()
    return output

  checkDateFormat = (dateString) ->
    regex = /^\d{1,2}\/\d{1,2}\/\d{4}$/
    return regex.test(dateString) || dateString == ''

$(document).ready(ready)
$(document).on('turbo:load', ready)
